import { render } from "./FacturacionMensualView.vue?vue&type=template&id=0bca0215&scoped=true"
import script from "./FacturacionMensualView.vue?vue&type=script&lang=js"
export * from "./FacturacionMensualView.vue?vue&type=script&lang=js"

import "./FacturacionMensualView.vue?vue&type=style&index=0&id=0bca0215&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bca0215"]])

export default __exports__